// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"e41fa5a2","184":"d0add9f3","290":"17b50cfa"}[chunkId] + ".chunk.js";
};